import { hasPrivileges } from "utils";

export default function hasAdminPrivileges(roles) {
  return hasPrivileges(
    roles,
    [
      "processing.isAdmin",
      "callcenter.isAdmin",
      "processing.isSuperAdmin",
      "callcenter.isSuperAdmin",
    ],
    false
  );
}



// WEBPACK FOOTER //
// ./src/utils/hasAdminPrivileges.js